import React, { useState } from 'react';
import { func } from 'prop-types';
import {
  NativeDropdown,
  FormController,
  FormLabel,
  MenuItem
} from '@one-thd/sui-atomic-components';
import { MulchTooltip } from './MulchTooltip';

export const MulchOptions = ({ handleBagSize }) => {

  let [sizeOption, setSizeOption] = useState('wood');

  const mulchType = [
    {
      name: 'Wood',
      value: 'wood'
    },
    {
      name: 'Top Soil',
      value: 'top soil'
    },
    {
      name: 'Rubber',
      value: 'rubber'
    }
  ];

  const wood = [
    {
      name: '1.5 cu. ft. bags',
      value: '1.5',
    },
    {
      name: '2 cu. ft. bags',
      value: '2',
    }
  ];

  const topSoil = [
    {
      name: '0.75 cu. ft. bags',
      value: '0.75',
    },
    {
      name: '1 cu. ft. bags',
      value: '1',
    },
    {
      name: '1.5 cu. ft. bags',
      value: '1.5',
    }
  ];

  const rubber = [
    {
      name: '0.8 cu. ft. bags',
      value: '0.8',
    }
  ];

  if (sizeOption === 'wood') {
    sizeOption = wood;
  } else if (sizeOption === 'top soil') {
    sizeOption = topSoil;
  } else {
    sizeOption = rubber;
  }

  return (
    <>
      <div className="sui-grid sui-grid-cols-2 sui-pt-2">
        <div className="sui-pr-3 sui-pb-2">
          <FormController fullWidth>
            <FormLabel>Type</FormLabel>
            <NativeDropdown onChange={(event) => { setSizeOption(event.target.value.toLowerCase()); }}>
              {mulchType.map(type => <MenuItem key={type?.value}>{type?.name}</MenuItem>
              )}
            </NativeDropdown>
          </FormController>
        </div>
        <div>
          <FormController fullWidth>
            <FormLabel>Bag Size</FormLabel>
            <NativeDropdown onChange={handleBagSize}>
              {sizeOption.map((size) => <MenuItem key={size?.value}>{size?.name}</MenuItem>
              )}
            </NativeDropdown>
          </FormController>
        </div>
      </div>
      <MulchTooltip />
    </>
  );
};

MulchOptions.propTypes = {
  handleBagSize: func.isRequired
};

MulchOptions.defaultProps = {};
